import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialog } from '@angular/material/dialog';
import { SignaturePopupComponent } from '../signature-popup/signature-popup.component';
import { HomeClaimPages, MotorClaimPages } from 'app/modules/claims/models/models';
import { HomeQuotePages, PaymentPriceAndPlanValue } from 'app/modules/quotes/models/models';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UserProfile } from 'app/services/user.service';
import { convertBlobToDataURL } from '@shared/utility/helperMethods';
import { DialogPopupComponent } from '../dialog-popup/dialog-popup.component';

@Component({
  selector: 'app-declaration',
  templateUrl: './declaration.component.html',
  styleUrls: ['./declaration.component.scss'],
  standalone: true,
  imports: [
    MatTooltipModule,
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule
  ]
})
export class DeclarationComponent implements OnInit, OnChanges {
  private _dialog: MatDialog = inject(MatDialog);
  private _sanitizer = inject(DomSanitizer);

  @Input() declarationText = '';
  @Input() previousPage: number;
  @Input() profile: UserProfile;
  @Input() fileName: string = null;
  @Input() pdfFile: any = null;
  @Input() submitBtnLabel = 'keywords.common.submit';
  @Input() signature: string = null;
  @Input() paymentPriceAndPlan: PaymentPriceAndPlanValue;

  @Output() showPDF = new EventEmitter<string>();
  @Output() saveDraft = new EventEmitter<void>();
  @Output() submitPolicy = new EventEmitter<boolean>();
  @Output() backClicked = new EventEmitter<HomeClaimPages | MotorClaimPages | HomeQuotePages>();

  pdfFileURL: SafeUrl;
  pdfFileContent: string;
  hasSignature = false;
  hidePdf = true;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.pdfFile?.currentValue) {
      const url = window.URL.createObjectURL(this.pdfFile);
      this.pdfFileURL = this._sanitizer.bypassSecurityTrustResourceUrl(url);

      convertBlobToDataURL(this.pdfFile).then(fileString => {
        this.pdfFileContent = fileString.split('base64,')[1];
      });
    }
  }

  ngOnInit(): void {}

  hideShowPDF() {
    if (!this.hasSignature) {
      this.hidePdf = !this.hidePdf;
      if (!this.hidePdf) this.createPDFDocument();
    }
  }

  createPDFDocument() {
    this.showPDF.emit();
  }

  saveAsDraft() {
    this.saveDraft.emit();
  }

  back() {
    if (this.hasSignature) return;
    this.backClicked.emit(this.previousPage);
  }

  openSignaturePopup() {
    this.hasSignature = true;
    // const dialogRef = this._dialog
    //   .open(SignaturePopupComponent, {
    //     data: {
    //       pdfFileContents: this.pdfFileContent,
    //       fileName: this.fileName,
    //       user: this.profile
    //     }
    //   })
    //   .afterClosed()
    //   .subscribe((res?: any) => {
    //     if (res) {
    //       this.pdfFile = res;
    //       this.hasSignature = true;
    //       const url = window.URL.createObjectURL(this.pdfFile);
    //       this.pdfFileURL = this._sanitizer.bypassSecurityTrustResourceUrl(url);
    //     }

    //     dialogRef.unsubscribe();
    //   });
  }

  submit() {
    if (this.fileName.includes('Quote')) {
      const dialogRef = this._dialog.open(DialogPopupComponent, {
        width: '600px'
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'redirect') {
          this.submitPolicy.emit();
        }
      });
    } else this.submitPolicy.emit();
  }
}
